import React from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import makeSlug from "./../../modules/makeSlug";
import Layout from "./../../components/Layout";
import BibliographyEntry from "./../../components/BibliographyEntry";
import Collection from "./../../components/Collection";
import MarkdownSpan from "./../../components/MarkdownSpan";
import {
  ItemWrapper,
  ImageDataDiv,
  NotesP,
  CollectionText,
  FullNameText,
} from "./elements";

// [Caption for Website] - in H4 or so
// [Notes for Website] - in styled text 1.2 em - if they exist, if not, leave one line
// [Proper Citation (from Bibliography)] a new related field that comes from the Bibliographies table - in styled text 1em - if it exists
// Tags – I’m proposing that we show the Section entries here for a start, but also allow other tags eventually. I didn’t do these in the screenshot
// [Collection Reference Text] - 0.8em bold - if it exists
// [Full Name (from Collection)] - 1 em bold - almost but not quite always exists
// [Persistent URL] - 0.8em - linkable, if it exists | copyright statement (must have)

const ItemPage = ({ data, pageContext }) => {
  const myData = data.airtable.data;
  const myRecordId = data.airtable.recordId;
  // console.log(myData);
  // console.log(pageContext.id);
  return (
    <Layout>
      <ItemWrapper>
        <div>
          {myData.Image_File &&
          (myData.Image_File.large || myData.Image_File.small) ? (
            <div>
              <a
                href={myData.Image_File.large[0].publicURL}
                target="_blank"
                rel="noreferrer"
              >
                <Img
                  fluid={[
                    myData.Image_File.large[0].childImageSharp.fluid,
                    {
                      ...myData.Image_File.small[0].childImageSharp.fluid,
                      media: `(max-width: 1023px)`,
                    },
                  ]}
                  alt={myData.Title}
                />
              </a>
            </div>
          ) : null}
          <ImageDataDiv>
            <h2>
              <MarkdownSpan text={myData.Caption_for_Website} />
            </h2>
            {myData.Notes_for_Website ? (
              <NotesP id="notesforwebsite">
                <MarkdownSpan text={myData.Notes_for_Website} />
              </NotesP>
            ) : null}
            <BibliographyEntry id={myRecordId} />
            {myData.Section && myData.Section.length ? (
              <ul id="tags">
                <strong>Tags:</strong>{" "}
                {myData.Section.map((section, index) => (
                  <li key={index}>
                    <Link to={`/section/${makeSlug(section)}`}>{section}</Link>
                  </li>
                ))}
              </ul>
            ) : null}
            {myData.Creator ? (
              <p id="creator">
                <strong>Creator:</strong> {myData.Creator}
              </p>
            ) : null}
            {myData.Full_Name__from_Collection_ &&
            myData.Full_Name__from_Collection_.length ? (
              <FullNameText id="fullnamefromcollection">
                {myData.Full_Name__from_Collection_.join("")}
              </FullNameText>
            ) : null}
            {null && myData.Collection && myData.Collection.length ? (
              <CollectionText id="collection">
                <Collection list={myData.Collection} />
              </CollectionText>
            ) : null}
            {myData.Collection_Reference_Text &&
            myData.Collection_Reference_Text.trim() ? (
              <CollectionText id="collectionreferencetext">
                <strong>ref:</strong> {myData.Collection_Reference_Text}
              </CollectionText>
            ) : null}
            {myData.Persistent_URL || myData.Image_URL ? (
              <CollectionText id="persistenturl">
                <a
                  href={myData.Persistent_URL || myData.Image_URL}
                  targt={"_blank"}
                >
                  {myData.Persistent_URL || myData.Image_URL}
                </a>
              </CollectionText>
            ) : null}
            {myData.Copyright ? (
              <p id="copyright">
                <strong>Copyright:</strong> {myData.Copyright}
              </p>
            ) : null}
          </ImageDataDiv>
        </div>
      </ItemWrapper>
    </Layout>
  );
};

export default ItemPage;

export const query = graphql`
  query ItemQuery($id: String) {
    airtable(id: { eq: $id }) {
      id
      recordId
      data {
        Caption_for_Website
        Notes_for_Website
        Proper_Citation__from_Bibliography_
        Collection
        Collection_Reference_Text
        Full_Name__from_Collection_
        Persistent_URL
        Section
        Creator
        Image_URL
        Copyright
        Image_File {
          large: localFiles {
            publicURL
            childImageSharp {
              fluid(maxWidth: 1024) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          small: localFiles {
            childImageSharp {
              fluid(maxWidth: 512) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;
